import { ENUM_TYPE_DOWNLOAD } from 'constants/enum';
import { CLEAR_REPORT, SET_OPEN_DOWNLOAD, SET_REPORT_BY_DATE } from 'store/types/report';

const initialState = {
  openDownload: {
    isOpen: false,
    type: ENUM_TYPE_DOWNLOAD.CSV,
  },
  reportByDate: [],
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_DOWNLOAD:
      return {
        ...state,
        openDownload: action?.payload,
      };
    case SET_REPORT_BY_DATE:
      return {
        ...state,
        reportByDate: action?.payload,
      };
    case CLEAR_REPORT:
      return {
        ...state,
        openDownload: initialState.openDownload,
        reportByDate: initialState.reportByDate,
      };
    default:
      return state;
  }
};

export default reportReducer;
